import { ThemeType } from '@/enums/themeType';
import { DetailedBet } from '@/models/detailed-bet';
import { Setting } from '@starsoft/common/models';

export type LiveBetsStateProps = {
  bets: Array<DetailedBet>;
};

export enum LiveBetActions {
  AddBet = 'live-bets/set',
}

export interface LiveBetBasePayload<T extends LiveBetActions, V = null> {
  type: T;
  payload: V;
}
export type AddBetPayload = LiveBetBasePayload<
  LiveBetActions.AddBet,
  DetailedBet
>;

export type LiveBetStatePayload = AddBetPayload;
